// Modules
import Common from "./modules/common";
import Animate from "./modules/animate";
import Header from "./modules/header";
import Lightbox from "./modules/lightbox";
import OB from "./modules/outdated-browser";

// Autoload modules
const modules = [Common, Animate, Header, Lightbox, OB];

modules.forEach((module) => {
  module.init();
});

// import local dependencies
import Router from "./utils/Router";
import templateHome from "./partials/template-home";
import templatePortfolio from "./partials/template-portfolio";
import singlePortfolio from "./partials/single-portfolio";
import singlePost from "./partials/single-post";
import templateContacts from "./partials/template-contacts";
import templateServices from "./partials/template-services";
import templateCareer from "./partials/template-career";
import pageSearch from "./partials/page-search";

// Populate Router instance with DOM routes
const routes = new Router({
  templateHome,
  templatePortfolio,
  singlePortfolio,
  singlePost,
  templateContacts,
  templateServices,
  templateCareer,
  pageSearch,
});

// Load Events
routes.loadEvents();
